module.exports = __webpack_public_path__ + "img/pk.d4d1e970.png";